import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute, AdminRoute } from "@/components/Guards";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import CreatePage from "@/pages/CreatePage";
import Studio from "@/pages/Studio";
import Dashboard from "@/pages/Dashboard";
import Library from "@/pages/Library";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import Contact from "@/pages/Contact";
import Examples from "@/pages/Examples";
import Admin from "@/pages/Admin";
import TermsOfService from "@/pages/legal/TermsOfService";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfPaidServices from "@/pages/legal/TermsOfPaidServices";
import CreditsPolicy from "@/pages/legal/CreditsPolicy";
import CommunityGuidelines from "@/pages/legal/CommunityGuidelines";
import CopyrightPolicy from "@/pages/legal/CopyrightPolicy";
// Pricing page is intentionally not imported: /pricing now redirects to /billing.
// eslint-disable-next-line no-unused-vars
const _keep = () => null;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />

      <Route element={<Layout />}>
        <Route path="/" element={<Landing />} />
        {/* /pricing → Credits & Billing (unauth users land on /login via ProtectedRoute) */}
        <Route path="/pricing" element={<Navigate to="/billing" replace />} />
        {/* Rename: Examples → Gallery. Keep /examples as a redirect so any
            existing links, sitemaps or bookmarks don't 404. */}
        <Route path="/gallery" element={<Examples />} />
        <Route path="/examples" element={<Navigate to="/gallery" replace />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms-paid-services" element={<TermsOfPaidServices />} />
        <Route path="/credits-policy" element={<CreditsPolicy />} />
        <Route path="/community-guidelines" element={<CommunityGuidelines />} />
        <Route path="/copyright-policy" element={<CopyrightPolicy />} />
        <Route path="/create" element={<ProtectedRoute><CreatePage /></ProtectedRoute>} />
        <Route path="/create/:service" element={<ProtectedRoute><Studio /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
        <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-center" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
